import { render } from "./DocumentsPrivate.vue?vue&type=template&id=27c778e2"
import script from "./DocumentsPrivate.vue?vue&type=script&lang=js"
export * from "./DocumentsPrivate.vue?vue&type=script&lang=js"

import "./DocumentsPrivate.vue?vue&type=style&index=0&id=27c778e2&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__